export default __webpack_public_path__ + "static/media/Incandescent Cane.898e2572.jpg";